<template>
  <div id="catalogoArea" class="contenedor">
    <Sidebar></Sidebar>
    <loader :show="show" />
    <v-container fluid class="base text-center ma-0 px-0 pt-6 pb-0">
      <v-row no-gutters class="titulo catalogoTitle">Agregar día Inhábil</v-row>
      <v-row class="catalogo catalogoList">
        <v-col cols="12" sm="8" class="py-3">Empresa Pagadora</v-col>
        <v-col cols="12" sm="4" class="py-3 selectGris">
          <select
            name="pagadora"
            id="pagadora"
            v-model="enterprise"
            @change="consultaVacaciones()"
          >
            <option disabled value="0">Selecciona</option>
            <option
              v-for="enterprise in enterprises"
              :key="enterprise.id"
              v-bind:value="enterprise.id"
            >
              {{ enterprise.razonSocial }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-3">Motivo del día</v-col>
        <v-col cols="12" sm="4" class="py-2 com">
          <input
            class="px-3"
            style="width: 90% !important"
            type="text"
            name="reason"
            id="reason"
            placeholder="Obligatorio"
            autocomplete="false"
            v-model="reason"
            required
            maxlength="20"
            @keypress="alfaNumerico($event)"
          />
        </v-col>
        <v-col cols="12" sm="8" class="py-3">Oficial</v-col>
        <v-col cols="12" sm="4" class="py-3 selectGris">
          <select name="oficial" id="oficial" v-model="oficial">
            <option selected disabled value="0">¿Es oficial?</option>
            <option value="1">Sí</option>
            <option value="2">No</option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-3">Fecha</v-col>
        <v-col cols="12" sm="4" class="py-2 com">
          <input
            class="px-3"
            style="width: 90% !important"
            type="date"
            name="date"
            id="date"
            placeholder="Obligatorio"
            autocomplete="false"
            v-model="date"
            required
            maxlength="20"
            @keypress="alfaNumerico($event)"
          />
        </v-col>
        <v-col cols="12" sm="12" class="mt-3 pa-0" align-self="end">
          <button class="boton" @click="validacion()">Siguiente</button>
        </v-col>
      </v-row>
    </v-container>
    <!--Error-->
    <v-dialog v-model="error" width="530">
      <v-card>
        <v-card-title class="red white--text">
          <span class="headline">{{ message }}</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-sm-center text-lg-center">
            {{ respuesta }}
          </h3>
          <br />
          <ul>
            <li v-for="error in errors" :key="error.name">{{ error }}</li>
          </ul>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="error = false">Corregir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Validación de datos-->
    <v-dialog v-model="advice" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">{{ message }}</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-lg-center text-sm-center">
            {{ respuesta }}
          </h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="red" text @click="cancelar()">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="guardar()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Confirmación de datos-->
    <v-dialog v-model="confirmation" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">{{ message }}</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-lg-center text-sm-center text-md-center">
            {{ respuesta }}
          </h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="auxiliar()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import Loader from "@/components/Loader";
export default {
  components: {
    Sidebar,
    Loader,
  },
  data() {
    return {
      stepn: "6-N",
      show: false,
      error: false,
      errors: [],
      respuesta: "",
      titulo: "",
      enterprise: 0,
      enterprises: [],
      advice: false,
      confirmation: false,
      days: [],
      message: "",
      oficial: 0,
      reason: "",
      date: "",
    };
  },
  methods: {
    nombre() {
      localStorage.stepn = this.stepn;
    },
    validacion() {
      //console.log("ID DE LA EMPRESA ES: " + localStorage.idEmpresa);
      this.errors = [];
      this.message = "Día inhábil";
      if (this.enterprise == "" || this.enterprise == 0) {
        this.errors.push("Se debe especificar la empresa.");
      }
      if (this.reason == "" || this.reason == " ") {
        this.errors.push("Se debe especificar el motivo del día inhábil.");
      }
      if (this.oficial == 0) {
        this.errors.push("Se debe especificar sí es o no oficial.");
      }
      if (this.date == "") {
        this.errors.push("Se debe especificar la fecha.");
      }
      if (this.errors.length == 0) {
        this.respuesta = "Esta seguro de la asignación de día inhábil.";
        this.advice = true;
      } else {
        this.respuesta = "Por favor corrige el siguiente error:";
        this.error = true;
      }
    },
    cancelar() {
      this.oficial = 0;
      this.date = "";
      this.reason = "";
      this.enterprise = 0;
      this.advice = false;
    },
    consultaVacaciones() {
      this.a0 = 0;
      this.a1 = 0;
      this.a2 = 0;
      this.a3 = 0;
      this.a4 = 0;
      this.a5 = 0;
      this.a10 = 0;
      this.a15 = 0;
      this.a20 = 0;
      this.a25 = 0;
      this.a30 = 0;
      this.a35 = 0;
      this.show = true;
      axios
        .get(Server + "/vacacionesAnio/empresa/" + this.enterprise)
        .then((response) => {
          this.show = false;
          var aux = response.data;
          if (aux.length > 0) {
            this.nuevoRegistro = false;
            (this.id = aux[0].id), (this.a0 = aux[0].anioCero);
            this.a1 = aux[0].anioUno;
            this.a2 = aux[0].anioDos;
            this.a3 = aux[0].anioTres;
            this.a4 = aux[0].anioCuatro;
            this.a5 = aux[0].anioCinco;
            this.a10 = aux[0].anioDiez;
            this.a15 = aux[0].anioQuince;
            this.a20 = aux[0].anioVeinte;
            this.a25 = aux[0].anioVeinticinco;
            this.a30 = aux[0].anioTreinta;
            this.a35 = aux[0].anioTreintaicinco;
          }
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },
    listar() {
      this.show = true;
      axios
        .get(Server + "/empresas")
        .then((response) => {
          this.show = false;
          this.enterprises = response.data;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },
    guardar() {
      this.advice = false;
      this.show = true;
      axios
        .post(Server + "/diaInhabil", {
          EmpresaId: this.enterprise,
          Motivo: this.reason,
          Oficial: this.oficial == "1" ? true : false,
          fecha: this.date,
        })
        .then((response) => {
          this.show = false;
          localStorage.idEmpresa = "";
          this.date = "";
          this.reason = "";
          this.oficial = 0;
          this.message = "Confirmación";
          this.respuesta = "El Día fue almacenado con éxito";
          this.confirmation = true;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
          localStorage.idEmpresa = "";
          this.date = "";
          this.reason = "";
          this.oficial = 0;
          this.message = "Aviso";
          this.respuesta = "El día no fue almacenado.";
          this.confirmation = true;
        });
    },
    auxiliar() {
      this.$router.push("/NonWorking");
    },
  },
  created() {
    this.nombre();
    for (let index = 1; index <= 60; index++) {
      this.days.push({
        id: index,
        name: index.toString(),
      });
    }
    this.listar();
  },
};
</script>